import { createTypes } from "../../utils/helpers";

const REPORTING_UNITS_FETCH: any = createTypes('REPORTING_UNITS_FETCH');
const REPORTING_UNITS_FETCH_RESTAURANTS: any = createTypes(
  'REPORTING_UNITS_FETCH_RESTAURANTS',
);
const REPORTING_UNITS_FETCH_BY_BRAND: any = createTypes('REPORTING_UNITS_FETCH_BY_BRAND');
const REPORTING_UNITS_GROUPS_FETCH: any = createTypes('REPORTING_UNITS_GROUPS_FETCH');
const REPORTING_UNITS_GROUP_RESTAURANTS_FETCH: any = createTypes('REPORTING_UNITS_GROUP_RESTAURANTS_FETCH');
const REPORTING_UNITS_GROUPS_COUNTRIES_FETCH: any = createTypes('REPORTING_UNITS_GROUPS_COUNTRIES_FETCH')
const REPORTING_UNITS_CLEAR = 'REPORTING_UNITS_CLEAR';
const REPORTING_UNITS_SET_FILTER_VALUE =
  'REPORTING_UNITS_SET_FILTER_VALUE';
const REPORTING_UNITS_CLEAR_FILTER_VALUE =
  'REPORTING_UNITS_CLEAR_FILTER_VALUE';
export {
  REPORTING_UNITS_FETCH,
  REPORTING_UNITS_CLEAR,
  REPORTING_UNITS_FETCH_RESTAURANTS,
  REPORTING_UNITS_FETCH_BY_BRAND,
  REPORTING_UNITS_GROUPS_FETCH,
  REPORTING_UNITS_GROUPS_COUNTRIES_FETCH,
  REPORTING_UNITS_GROUP_RESTAURANTS_FETCH,
  REPORTING_UNITS_SET_FILTER_VALUE,
  REPORTING_UNITS_CLEAR_FILTER_VALUE
};
